import PropTypes from 'prop-types';
import React, { useState } from 'react';

import FileUpload from '@/components/FileUpload';

const propTypes = {
  onLoadEmails: PropTypes.func,
};

export default function FileUploader({ onLoadEmails, onRemoveFile }) {
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState(null)
  const handleDropFile = file => {
    setLoading(true)
    const reader = new FileReader();
    reader.onload = () => {
      onLoadEmails(reader.result)
      setLoading(false)
    }
    reader.readAsText(file)
    setFile(file)
  }

  const handleRemoveFile = () => {
    setFile(null)
    onRemoveFile()
  }

  return <FileUpload
    type={['text/plain']}
    onUpload={handleDropFile}
    value={file}
    isLoading={loading}
    onRemove={handleRemoveFile}
  />
}

FileUploader.propTypes = propTypes
FileUploader.defaultProps = {}
